



















import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import List from '@/components/list'
import { ListType } from '@/util/types'
import PlayList from '@/components/playList'
import { courseItem } from '@/api/res'

@Component({
  components: {
    List,
    PlayList
  }
})
export default class CourseCreate extends ViewBase {
  cursorListType = ListType.cloudResource

  doc: any

  cloudSource: boolean = true

  lang: any = {}

  get cursorTab() {
    return this.tabList.find(tab => tab.value === this.cursorListType)
  }

  get needRefreshMyCourse() {
    return this.$store.state.needRefreshMyCourse
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  get tabList() {
    return [
        {
          value: ListType.cloudResource,
          label: this.i18n.cloudRes
        },
        {
          value: ListType.cloudCourse,
          label: this.i18n.courseIndex
        },
        {
          value: ListType.myCourse,
          label: this.i18n.courseMy
        },
        {
          value: ListType.myResource,
          label: this.i18n.ownerCourse
        }
      ]
  }

  created() {
    this.doc = window.document
    this.lang = this.i18n.VCourse
    const lang: any = this.lang
  }

  handleSelect(value: ListType) {
    if (value == 20) {
      this.cloudSource = true
    } else {
      this.cloudSource = false
    }
    this.cursorListType = value
  }

  @Watch('needRefreshMyCourse')
  watchNeedRefreshMyCourse(flag: boolean) {
    if (this.cursorListType === ListType.myCourse) {
      return
    }
    if (!flag) {
      return
    }
    this.$store.commit('setNeedRefreshMyCourse', false)
    this.cursorListType = ListType.myCourse
  }
}
